import axios from 'axios';
import config from '../config.js';

var root = config.authApiHost();
let uiHost = config.authUiHost();

let getConfig = function () {
    return {};
}

var http = axios.create({
    baseURL: root,
    timeout: 5000,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
});

async function get(path) {
    return http.get(path, getConfig());
}

async function post(path, data) {
    return http.post(path, data, getConfig());
}

async function del(path) {
    return http.delete(path, getConfig());
}

async function patch(path, data) {
    return http.patch(path, data, getConfig());
}



export default {
    get: get,
    post: post,
    del: del,
    patch: patch,
    host: root,
    uiHost: uiHost
}